import "./EthosButton.css";
// import EthosSpinner from "../EthosSpinner-storybook/EthosSpinner";

const EthosButton = ({ type, buttonWidth, buttonHeight, label, clear }) => {
  const isLoading = type.endsWith("-loading");
  let borderColor;
  const isClear = clear === true ? true : false;

  switch (type) {
    case "primary-loading":
      borderColor = "#FFFFFF";
      break;
    case "secondary-loading":
      borderColor = "#025093";
      break;
    default:
      borderColor = "";
  }

  const container = document.createElement("div");
  container.innerHTML = `
      <link href='https://fonts.googleapis.com/css?family=Inter' rel='stylesheet'>
      <div
        type="button"
        class="ethosButton ${type}"
        style="
          width: ${buttonWidth}px;
          height: ${buttonHeight}px;
        "
      >
        <div class='${
          isClear ? "ethos-button-label-clear" : "ethos-button-label"
        }'>${label}</div>
    `;

  return container;
};

export default EthosButton;
